var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item"},[_c('el-badge',{staticClass:"item",attrs:{"value":_vm.unreadMessageTotal,"max":99,"hidden":_vm.unreadMessageTotal == 0}},[_c('el-button',{attrs:{"icon":"el-icon-chat-round","circle":"","size":"small"},on:{"click":function($event){return _vm.$bus.$emit('toggle-tenant-messaging', !_vm.visible)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }